<template>
  <div v-if="isOpen" class="fixed inset-0 z-[10000] overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <!-- Overlay de fond -->
      <div class="fixed inset-0 transition-opacity" @click="close">
        <div class="absolute inset-0 bg-gray-900/70"></div>
      </div>

      <!-- Modal -->
      <div class="inline-block align-bottom bg-white dark:bg-gray-800 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-6xl sm:w-full">
        <div class="px-5 pt-5 pb-4 sm:px-6 sm:pb-5">
          <div class="sm:flex sm:items-start">
            <div class="mt-2 sm:mt-0 sm:text-left w-full">
              <h3 class="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-gray-800 dark:text-white">Mentions légales</h3>

              <div class="space-y-5">
                <section>
                  <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Propriété</h4>
                  <p class="mb-2 text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                    Cette application est la propriété exclusive de K&C Madin Invest.
                  </p>
                  <p class="text-gray-600 dark:text-gray-400 text-sm md:text-base">
                    <!-- Siège social : [Adresse du siège social] -->
                    <!-- SIRET : [Numéro SIRET] -->
                  </p>
                </section>

                <section>
                  <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Limitation de responsabilité</h4>
                  <p class="mb-2 text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                    Les informations contenues dans cette application sont fournies à titre informatif uniquement. K&C Madin Invest ne peut garantir l'exactitude, la complétude ou la pertinence des informations mises à disposition dans le cadre de l'application.
                  </p>
                  <p class="text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                    Les décisions prises sur la base des informations fournies par l'application relèvent de la seule responsabilité de l'utilisateur. K&C Madin Invest ne pourra en aucun cas être tenue responsable des dommages directs ou indirects résultant de l'utilisation de ces informations.
                  </p>
                </section>

                <section>
                  <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Protection des données</h4>
                  <p class="text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                    Conformément à la législation en vigueur, l'utilisateur dispose d'un droit d'accès, de rectification et de suppression des données le concernant. L'utilisateur peut supprimer définitivement son compte à tout moment via le menu « Compte » dans l'application. Pour toute autre demande, l'utilisateur peut contacter K&C Madin Invest à l'adresse indiquée ci-dessus.
                  </p>
                </section>

                <section>
                  <h4 class="text-lg md:text-xl font-semibold mb-2 md:mb-3 text-gray-700 dark:text-gray-200">Cookies et stockage local</h4>
                  <p class="mb-2 text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                    Cette application utilise uniquement des cookies techniques nécessaires à son fonctionnement :
                  </p>
                  <ul class="mb-2 text-gray-600 dark:text-gray-400 text-sm md:text-base ml-4 space-y-1">
                    <li>• <strong>Cookies de session</strong> : Maintien de votre connexion sécurisée</li>
                    <li>• <strong>Cookies CSRF</strong> : Protection contre les attaques de type Cross-Site Request Forgery</li>
                    <li>• <strong>Stockage local</strong> : Sauvegarde temporaire de vos préférences d'authentification</li>
                  </ul>
                  <p class="text-gray-600 dark:text-gray-400 text-justify text-sm md:text-base">
                    <strong>Aucun cookie de tracking, publicitaire ou d'analyse n'est utilisé.</strong> 
                    Tous les cookies sont sécurisés (transmission HTTPS uniquement) et ne contiennent aucune donnée personnelle sensible. 
                    Vous pouvez supprimer ces données à tout moment via les paramètres de votre navigateur.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 dark:bg-gray-700 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <button 
            @click="close" 
            type="button" 
            class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:ml-3 sm:w-auto sm:text-sm"
          >
            Fermer
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'LegalModal',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup(props, { emit }) {
    const close = () => {
      emit('close')
    }
    
    return {
      close
    }
  }
})
</script>

